export default __webpack_public_path__ + "static/media/151.4e18dad5.jpg";